import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import Problem from './components/sections/Problem';
import Revelation from './components/sections/Revelation';
import HowItWorks from './components/sections/HowItWorks';
import Features from './components/sections/Features';
import Testimonials from './components/sections/Testimonials';
import FAQ from './components/sections/FAQ';
import CTASection from './components/sections/CTA';
import StickyCTA from './components/sections/StickyCTA';

function App() {
  return (
    <div className="min-h-screen bg-surface text-white">
      <Header />
      <main>
        <Hero />
        <Problem />
        <Revelation />
        <HowItWorks />
        <Features />
        <Testimonials />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}

export default App;
